var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastPageArrowPagination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2103 11.9987L7.90985 7.90301C7.59255 7.60082 7.59255 7.11087 7.90985 6.80867C8.22715 6.50648 8.7416 6.50648 9.0589 6.80867L13.9339 11.4515C14.2512 11.7537 14.2512 12.2437 13.9339 12.5459L9.0589 17.1887C8.7416 17.4909 8.22715 17.4909 7.90985 17.1887C7.59255 16.8865 7.59255 16.3966 7.90985 16.0944L12.2103 11.9987Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3209 7.31203C16.3209 6.9808 16.216 6.61648 15.8862 6.58613C15.8573 6.58348 15.8266 6.58203 15.7942 6.58203C15.7078 6.58203 15.6328 6.58844 15.5679 6.59908C15.2688 6.64814 15.1719 6.9649 15.1719 7.268V16.7559C15.1719 17.042 15.2598 17.3417 15.541 17.3941C15.6118 17.4072 15.6955 17.4154 15.7942 17.4154C15.8262 17.4154 15.8565 17.414 15.8851 17.4114C16.2156 17.3813 16.3209 17.0162 16.3209 16.6844V7.31203Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastPageArrowPagination);
export default __webpack_public_path__ + "static/media/last-page-arrow-pagination.c5d15c706b4a6d8ce9ee87e96b4a1b42.svg";
export { ForwardRef as ReactComponent };